<ng-container *ngIf="!item.hidden">

    
     <div class="group-title" [ngClass]="item.classes">
        <span style="font-size: 15px; color:#395ee1c4 !important;"  class="hint-text" [translate]="item.translate"> {{ item.title }} </span>
    </div>
    
    <div class="group-items">
        <ng-container *ngFor="let item of item.children">
            <ross-nav-vertical-group *ngIf="item.type=='group'" [item]="item"></ross-nav-vertical-group>
            <ross-nav-vertical-collapsable *ngIf="item.type=='collapsable'"
                                           [item]="item"></ross-nav-vertical-collapsable>
            <ross-nav-vertical-item *ngIf="item.type=='item'" [item]="item"></ross-nav-vertical-item>
        </ng-container>
    </div>

</ng-container>